module.exports = __webpack_public_path__ + "static/img/blueback.8dbfb11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blueback.png
// module id = zYEx
// module chunks = 1